// index.js
'use strict'
const Compound = require('./lib/Compound.js');
const PeriodicTable = require('./lib/PeriodicTable.js');
const Utility = require('./lib/Utility.js');

module.exports = {
	Compound: Compound,
	PeriodicTable: PeriodicTable,
	Utility: Utility
}
